import { z } from '../../zod';
import {
  CursorPaginationValidationBaseSchema,
  SellerAPICursorPaginationValidationSchema,
  withCursorPaginationValidation,
} from '../../shared/cursorPagination';

export const ThemeScopeValidationEnum = z.enum(['global', 'seller']).meta({
  description:
    '`global`: a built-in theme every account can use. It is read-only; copy it with `baseThemeId` to change it. `seller`: a theme your account created.',
});

const themeListFilterFields = {
  scope: ThemeScopeValidationEnum.optional().meta({
    description:
      'Only return built-in themes (`global`) or themes your account created (`seller`).',
  }),
} as const;

// Same filters, two pagination bases: native numbers for the MCP tool, string coercion for URL query params.
export const ThemeListQueryValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend(themeListFilterFields),
);

export const ThemeListSellerAPIQueryValidationSchema = withCursorPaginationValidation(
  SellerAPICursorPaginationValidationSchema.extend(themeListFilterFields),
);
